'use strict';

// In production, we register a service worker to serve assets from local cache.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.

// To learn more about the benefits of thisNew content is available; please refresh model, read https://goo.gl/KwvDNy.

import { Log } from '@utils';

/**
 * App Service Worker Class
 *
 * @export
 * @class AppServiceWorker
 */
export class AppServiceWorker {

	private static instance: AppServiceWorker;
	private isLocalhost: boolean;
	private installPromise: Promise<unknown>;
	private updatePromise: Promise<unknown>;
	private installPromiseResolver: (resolve?: unknown) => void;
	private updatePromiseResolver: (resolve?: unknown) => void;

	/**
	 * Creates an instance of AppServiceWorker.
	 *
	 * @memberof AppServiceWorker
	 */
	constructor() {
		this.isLocalhost = Boolean(
			window.location.hostname === 'localhost' ||
			// [::1] is the IPv6 localhost address.
			window.location.hostname === '[::1]' ||
			// 127.0.0.1/8 is considered localhost for IPv4.
			window.location.hostname.match(
				/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/,
			),
		);

		this.installPromise = new Promise((resolve) => this.installPromiseResolver = resolve);
		this.updatePromise = new Promise((resolve) => this.updatePromiseResolver = resolve);

		this.onUpdateFound(() => Log.message('New content is available; please refresh.'));
		this.onInstalled(() => Log.message('Content is cached for offline use.'));
	}

	static getInstance() {
		return this.instance ? this.instance : this.instance = new this().register();
	}

	register(swUrl = '/service-worker.js') {
		if ('serviceWorker' in navigator) {
			// The URL constructor is available in all browsers that support SW.
			// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
			// @ts-ignore
			const publicUrl = new URL(process.env.PUBLIC_URL, window.location);
			if (publicUrl.origin !== window.location.origin) {
				// Our service worker won't work if PUBLIC_URL is on a different origin
				// from what our page is served on. This might happen if a CDN is used to
				// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
				return;
			}

			window.addEventListener('load', () => {
				if (this.isLocalhost) {
					// This is running on localhost. Lets check if a service worker still exists or not.
					this.checkValidServiceWorker(swUrl);

					// Add some additional logging to localhost, pointing developers to the
					// service worker/PWA documentation.
					void navigator?.serviceWorker.ready.then(() => {
						Log.message(
							'This web app is being served service ' +
							'worker. To learn more, visit https://goo.gl/SC7cgQ',
						);
					});
				} else {
					// Is not local host. Just register service worker
					this.registerValidSW(swUrl);
				}
			});
		}
		return this;
	}

	registerValidSW(swUrl: string) {
		// let endpoint;
		// let key;
		// let authSecret;

		navigator?.serviceWorker?.register(swUrl, { scope: './' })
			.then((registration: ServiceWorkerRegistration) => {
				registration.onupdatefound = () => {
					const installingWorker = registration.installing;
					installingWorker.onstatechange = () => {
						if (installingWorker.state === 'installed') {
							if (navigator.serviceWorker.controller) {
								// At this point, the old content will have been purged and
								// the fresh content will have been added to the cache.
								// It's the perfect time to display a "New content is
								// available; please refresh." message in your web app.
								this.updatePromiseResolver();
							} else {
								// At this point, everything has been precached.
								// It's the perfect time to display a
								// "Content is cached for offline use." message.
								this.installPromiseResolver();
							}
						}
					};
				};

				// todo: Сделать подписку на нотифаи (нужно взаимоодействие с сервером)
				// return registration.pushManager.getSubscription()
				// 	.then(function(subscription) {
				// 		// Если подписка уже существует возвращаем ее.
				// 		if (subscription) {
				// 			return subscription;
				// 		}
				// 		// В противном случае, подписываем пользователя.
				// 		// userVisibleOnly - это флаг указывающий, что возвращенная push-подписка
				// 		// будет использоваться только для сообщений,
				// 		// эффект которых будет виден для пользователя.
				// 		return registration.pushManager.subscribe({ userVisibleOnly: true });
				// 	});
			})
			// .then((subscription) => {
			// 	// Получаем public key для пользователя.
			// 	const rawKey = subscription.getKey ? subscription.getKey('p256dh') : '';
			// 	key = rawKey
			// 		? btoa(String.fromCharCode.apply(null, new Uint8Array(rawKey)))
			// 		: '';
			// 	const rawAuthSecret = subscription.getKey ? subscription.getKey('auth') : '';
			// 	authSecret = rawAuthSecret
			// 		? btoa(String.fromCharCode.apply(null, new Uint8Array(rawAuthSecret)))
			// 		: '';
			//
			// 	// endpoint = subscription.endpoint;
			//
			// 	// Отправляем детали о подписке на сервер используя Fetch API
			// 	void fetch('./register', {
			// 		method: 'post',
			// 		headers: {
			// 			'Content-type': 'application/json',
			// 		},
			// 		body: JSON.stringify({
			// 			endpoint: subscription.endpoint,
			// 			key,
			// 			authSecret,
			// 		}),
			// 	});
			// })
			.catch((error) => {
				Log.error('Error during service worker registration:', error);
			});
	}

	checkValidServiceWorker(swUrl: string) {
		Log.message('checkValidServiceWorker', swUrl);
		// Check if the service worker can be found. If it can't reload the page.
		fetch(swUrl)
			.then((response) => {
				// Ensure service worker exists, and that we really are getting a JS file.
				if (
					response.status === 404 ||
					!response.headers.get('content-type')
						.includes('javascript')
				) {
					// No service worker found. Probably a different app. Reload the page.
					void navigator.serviceWorker.ready.then((registration) => {
						void registration.unregister()
							.then(() => {
								window.location.reload();
							});
					});
				} else {
					// Service worker found. Proceed as normal.
					this.registerValidSW(swUrl);
				}
			})
			.catch(() => {
				Log.error(
					'No internet connection found. App is running in offline mode.',
				);
			});
	}

	static unregister() {
		if (navigator && 'serviceWorker' in navigator) {
			void navigator.serviceWorker.ready.then((registration) => {
				void registration.unregister();
			});
		}
	}

	onInstalled(callback: (value?: unknown) => void) {
		this.installPromise.then(callback)
			.catch(Log.error);
	}

	onUpdateFound(callback: (value?: unknown) => void) {
		this.updatePromise.then(callback)
			.catch(Log.error);
	}

}

/**
 * The default register service worker function
 * @return {AppServiceWorker}
 */
export function registerServiceWorker() {
	return AppServiceWorker.getInstance();
}
